// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  origin: 'https://mpapitest-1.radiantdelivers.com/api/v1/gd/',
  mock: false,
  version: require( '../../config.json' ).version,
  gtagId: '', // leave this blank
  lambdaApi: 'https://rgl-node-fourpl-portal-dev.radiantdelivers.com/',
  localLambdaApi: 'http://localhost:3000/',
  maintenanceUrl: 'https://rgl-static-cdn.s3.amazonaws.com/maintenance_dev.json',
};
